import clsx from 'clsx';

export type BadgeVariant =
  | 'default'
  | 'primary'
  | 'success'
  | 'warning'
  | 'danger'
  | 'info'
  | 'purple';

interface BadgeProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
  className?: string;
}

const variantClasses: Record<BadgeVariant, string> = {
  default: 'bg-gray-100 text-gray-700',
  primary: 'bg-barrikadave-100 text-barrikadave-700',
  success: 'bg-emerald-100 text-emerald-700',
  warning: 'bg-amber-100 text-amber-700',
  danger: 'bg-red-100 text-red-700',
  info: 'bg-sky-100 text-sky-700',
  purple: 'bg-purple-100 text-purple-700',
};

export default function Badge({
  children,
  variant = 'default',
  className,
}: BadgeProps) {
  return (
    <span
      className={clsx(
        'inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium',
        variantClasses[variant],
        className,
      )}
    >
      {children}
    </span>
  );
}

export function getRoleBadgeVariant(
  role: string,
): BadgeVariant {
  switch (role) {
    case 'ADMIN':
      return 'primary';
    case 'USER':
      return 'info';
    default:
      return 'default';
  }
}

export function getStatusBadgeVariant(
  status: string,
): BadgeVariant {
  switch (status) {
    case 'ACTIVE':
      return 'success';
    case 'PENDING':
      return 'warning';
    case 'SUSPENDED':
      return 'warning';
    case 'DEACTIVATED':
      return 'danger';
    default:
      return 'default';
  }
}

export function getPriorityBadgeVariant(
  priority: string,
): BadgeVariant {
  switch (priority) {
    case 'URGENT':
      return 'danger';
    case 'IMPORTANT':
      return 'warning';
    case 'NORMAL':
      return 'info';
    default:
      return 'default';
  }
}
